import { Component, h, Element, Prop, Event, EventEmitter } from '@stencil/core';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import { blobToBase64 } from '../../../utils/utils';

import logoOntrace from '../../../assets/logo-ontrace.svg';

@Component({
  tag: 'id-capture-confirm',
  shadow: false,
})
export class IdCaptureConfirm {
  private translations: TranslationValues;

  @Element() component: HTMLElement;

  @Prop() capture: File;
  private image: string;

  constructor() {}

  @Event({
    eventName: 'idCaptureConfirmation',
  })
  idCaptureConfirmation: EventEmitter;

  @Event({
    eventName: 'idCaptureRetry',
  })
  idCaptureRetry: EventEmitter;

  async componentWillLoad() {
    this.translations = await Translations.getValues();
    this.image = await blobToBase64(this.capture);
  }

  async componentDidLoad() {}

  private confirm() {
    this.idCaptureConfirmation.emit();
  }

  private retry() {
    this.idCaptureRetry.emit();
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-2 w-100">
          <h1 class="text-center px-1 mb-2" innerHTML={this.translations.IdCaptureConfirmValues.Title}></h1>

          <div class="mb-3">
            <img class="w-100 rounded" src={this.image}></img>
          </div>

          <div class="button flex mb-1 mx-3">
            <button class="main-button" type="button" onClick={() => this.confirm()}>
              {this.translations.IdCaptureConfirmValues.Confirm}
            </button>
          </div>
          <div class="text-center">
            <p class="main-text link-text" onClick={() => this.retry()}>
              {this.translations.IdCaptureConfirmValues.Retry}
            </p>
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
